var render = function render(){
  var _vm$item, _vm$item2, _vm$item4, _vm$item5, _vm$item6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', {
    attrs: {
      "pageHeaderBackgroundImageSrc": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.imageURL,
      "hasOverlay": true,
      "headerBackgroundOpacity": 0.7
    }
  }, [_c('PageHeaderTitleContent', [_c('div', {
    staticClass: "w-100 d-flex flex-column justify-content-center align-items-center"
  }, [_c('TitleTextContent', {
    attrs: {
      "titleText": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.title
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center mt-3",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-column flex-lg-row flex-xl-row align-items-center justify-content-center justify-content-lg-between justify-content-xl-between"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.isRecentPapers === true ? 'white-papers' : 'white-papers-archives',
        query: {
          paperPage: _vm.paperPage,
          query: _vm.query
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Read All Papers ")])], 1), _c('v-btn', {
    staticClass: "mt-3 mt-lg-0 mt-xl-0",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    },
    on: {
      "click": function () {
        var _vm$item3;
        return _vm.downloadWhitePaper((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.whitepaperLink);
      }
    }
  }, [_vm._v(" Download White Paper ")])], 1)])], 1)])], 1), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'blogs-top',
      "isSocialMediaSiblingsVisible": true,
      "socialShareColumnClass": _vm.isRecentDate(_vm.item.date) ? 'col-12' : 'col-6'
    }
  }, [_c('div', {
    staticClass: "col-6 col-lg-3 col-xl-3 p-0"
  }, [_c('p', {
    staticClass: "post-snippet text-start"
  }, [_vm._v(_vm._s((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.author))])]), _vm.isRecentDate(_vm.item.date) ? _c('div', {
    staticClass: "col-6 col-lg-3 col-xl-3 p-0"
  }, [_c('p', {
    staticClass: "post-snippet text-right text-lg-left text-xl-left"
  }, [_vm._v(_vm._s(_vm.getFormattedDate((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.date)))])]) : _vm._e()]), _c('section', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "container-fluid my-3 px-3 px-lg-5 px-xl-5"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : _vm$item6.article)
    }
  }), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6 p-0 mb-lg-0 mb-xl-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start",
    class: _vm.previousButtonMarginBottomClass
  }, [_vm.previousPaperId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.previousPaperId, '#/white-paper-detail');
      }
    }
  }, [_vm._v(" Read Previous ")]) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6 p-0 mt-lg-0 mt-xl-0 d-flex flex-row justify-content-center justify-content-lg-end justify-content-xl-end",
    class: _vm.nextButtonMarginTopClass
  }, [_vm.nextPaperId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.nextPaperId, '#/white-paper-detail');
      }
    }
  }, [_vm._v(" Read Next ")]) : _vm._e()], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }